import { ContractInfo } from 'common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-10/frontend-integration';
import { fetchRequest } from './RequestSlice';
import { RequestDataSelector } from './RequestDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';

export function useRequest(): AbstractDataState<ContractInfo[], DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchRequest, RequestDataSelector);
}
